

export const atProp={
    name:"at",
    type:`"start"|"end"|number`,
    defaultValue:"end",
    description:`
        Sets the element initial location.
        @- start : at the beginning of the parent
        @- end : at the end of the parent
        @- number: at index
    `,
},innateHTML={
    name:"innateHTML",
    type:"string",
    description:`
        Safer version of innerHTML
        @Sets safely the HTML or XML markup contained within the element.
        @Excludes <span>script</span>, <span>style</span> and <span>embed</span> elements.
        @Excludes elements that have at least one attribute starting with "on".
        @Excludes any element whose style attribute containes "javascript:"
        @Excludes any element whose href attribute does not start with ["http:","https:","data:","m-files:","file:","ftp:","mailto:","pw:"]
        @Adds <span>type</span>, <span>alt</span> and <span>sandbox</span> attributes 
        respectively to <span>button</span>, <span>img</span> and <span>iframe</span> elements.
    `,
},queryAllSelectors={
    name:"queryAllSelectors",
    type:"(...selectors:string):Element[]",
    description:"returns a list of the first element-descendants of node that match every single selector",
};
